import { metadataBarChart, metadataBarChartHorizontal } from './metadata';
import { Chart, CategoryScale, LinearScale, BarElement, BarController, LineController, LineElement, PointElement, PieController, ArcElement, Tooltip, Title, Legend } from 'chart.js';
import { ApplyGradientOrSolidColor } from './gradientHelper';

Chart.register(CategoryScale, LinearScale, BarElement, BarController, LineController, LineElement, PointElement, PieController, ArcElement, Tooltip, Title, Legend);

/*
export function renderBarChart(canvas) {
  const ctx = canvas.getContext('2d');
  ApplyGradientOrSolidColor(metadataBarChart)

  const chart = new Chart(ctx, metadataBarChart);

  return chart;
}

export function renderBarChartHorizontal(canvas) {
  const ctx = canvas.getContext('2d');
  ApplyGradientOrSolidColor(metadataBarChartHorizontal)

  const chart = new Chart(ctx, metadataBarChartHorizontal);

  return chart;
}
*/

export function renderChart(canvas, metadata) {
  const ctx = canvas.getContext('2d');
  //console.log(metadata)
  if (metadata.type === 'bar')
    ApplyGradientOrSolidColor(metadata)

  const chart = new Chart(ctx, metadata);

  return chart;
}
